export default __webpack_public_path__ + "static/media/chainlink.20a91e52.svg";